import { render, staticRenderFns } from "./prop-node.vue?vue&type=template&id=5e3c72f6&scoped=true&"
import script from "./prop-node.vue?vue&type=script&lang=ts&"
export * from "./prop-node.vue?vue&type=script&lang=ts&"
import style0 from "./prop-node.vue?vue&type=style&index=0&id=5e3c72f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c72f6",
  null
  
)

export default component.exports